module.exports = angular.module('cartographer.common.datetime', [])

###
Conversions between dates and strings.

The browser must convert these objects to and from date/time strings
using the local time zone and daylight savings settings.
###

$      = require 'jquery'
_      = require 'underscore'
moment = require 'moment'

module.exports.factory 'crtDatetime', $DI (crtLog, $window, crtConfig, crtString) ->
  # This code uses library functions provided by date.js

  # arrayOf(string)
  dateFormats          = crtConfig.datetime.dateFormats
  timeFormats          = crtConfig.datetime.timeFormats
  datetimeFormats      = crtConfig.datetime.datetimeFormats
  parseFormats         = [].concat(dateFormats, timeFormats, datetimeFormats)
  displayFormat        = crtConfig.datetime.displayFormat
  iso8601ParseFormats  = crtConfig.datetime.iso8601ParseFormats
  iso8601DisplayFormat = crtConfig.datetime.iso8601DisplayFormat

  # -> Date
  create = ->
    moment.utc().toDate()

  # -> Date
  yearsAgo = (years) ->
    moment.utc().subtract(years, 'years').toDate()

  # -> Date
  oneYearAgo = ->
    yearsAgo(1)

  # string [arrayOf(string)] -> boolean
  _isDatetimeString = (str, formats = parseFormats) ->
    for format in formats when dateFormatToRegExp(format).test(str)
      return true
    return false

  # string -> string
  normalize = (str) ->
    # Split on spaces, assuming that each part is either a date or a time:
    _.chain($.trim(str).split(/\s+/))
      .map (part) ->
        # Determine the first delimeter character used:
        index = part.search(/[^0-9A-Z]/)
        delim = if index < 0 then '/' else part[index]
        # Replace all instances of one or more non-punctuation characters with `delim`:
        part.split(/[^0-9A-Z]+/).join(delim)
      .value()
      .join(" ")

  # string [format] [boolean] -> or(Date undefined)
  parse = (str, formats = parseFormats, strict = false) ->
    normalized = normalize(str)
    if _isDatetimeString(normalized, formats)
      mom = moment(normalized, formats, strict)
      if mom.isValid() then mom.toDate() else undefined
    else
      undefined

  parseDate = (str, strict = false) ->
    parse(str, dateFormats, strict)

  parseTime = (str, strict = false) ->
    parse(str, timeFormats, strict)

  # Date [string] -> string
  format = (date, format = displayFormat) ->
    moment(date).format(format)

  # string [or(string arrayOf(string))] -> date
  parseIso8601 = (str, formats = iso8601ParseFormats) ->
    if _isDatetimeString(str, formats)
      moment.utc(str, formats).toDate()
    else
      undefined

  # date [string] -> string
  formatIso8601 = (date, format = iso8601DisplayFormat) ->
    moment.utc(date).format(format)

  # date -> string
  formatAgo = (date) ->
    moment.utc(date).fromNow()

  # any -> boolean
  isDatetime = (obj) ->
    _.isDate(obj)

  # any -> boolean
  isDatetimeJson = (obj) ->
    _.isObject(obj) && obj.type == "Timestamp" && obj.iso8601?

  # datetimeObject -> Date
  decodeDatetimeJson = (date) ->
    if date.iso8601?
      parseIso8601(date.iso8601)
    else
      undefined

  # Date -> datetimeObject
  encodeDatetimeJson = (date) ->
    { type: "Timestamp", iso8601: formatIso8601(date) }

  # string -> RegExp
  dateFormatToRegExp = (fmt) ->
    ans = "^"
    escape = (str) ->
      str.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&')
    consume = (regex, result) ->
      match = fmt.match(regex)
      if match
        ans = ans + result(match)
        fmt = fmt.substring(match[0].length)
        true
      else
        false
    while fmt.length > 0
      # Date/time fields should be matched appropriately:
      consume( /^YYYY/,              -> '\\d{4}'         ) ||
      consume( /^YY/,                -> '\\d{2}'         ) ||
      consume( /^MM/,                -> '\\d{1,2}'       ) ||
      consume( /^DD/,                -> '\\d{1,2}'       ) ||
      consume( /^HH/,                -> '\\d{1,2}'       ) ||
      consume( /^mm/,                -> '\\d{1,2}'       ) ||
      consume( /^ss/,                -> '\\d{1,2}'       ) ||
      consume( /^SSS/,               -> '\\d{3}'         ) ||
      # Literal text (e.g. "[T]") should be matched exactly:
      consume( /^\[(.*?)\]/, (match) -> escape(match[1]) ) ||
      # One whitespace character in the format
      # should match one or more characters in the string:
      consume( /^\s/,                -> '\\s+'           ) ||
      # Any other (i.e. punctuation) character in the format
      # should match any punctuation character in the string:
      consume( /^./,                 -> '.'              )
    ans += "$"
    new RegExp(ans)

  isTimeString = (str) ->
    if typeof str == "string"
      match   = str.match(/^(\d{1,2})[:.](\d{1,2})$/)
      hours   = match && parseInt(match[1], 10)
      minutes = match && parseInt(match[2], 10)
      hours? && minutes? && hours >= 0 && hours <= 23 && minutes >= 0 && minutes <= 59
    else
      false

  formatTimeString = (str) ->
    match   = str.match(/^(\d{1,2})[:.](\d{1,2})$/)
    hours   = match && parseInt(match[1], 10)
    minutes = match && parseInt(match[2], 10)
    if hours? && minutes? && hours >= 0 && hours <= 23 && minutes >= 0 && minutes <= 59
      "#{crtString.addLeadingZeroes(hours, 2)}:#{crtString.addLeadingZeroes(minutes, 2)}"
    else
      str

  return {
    create
    yearsAgo
    oneYearAgo
    dateFormats
    timeFormats
    parseFormats
    displayFormat
    iso8601ParseFormats
    iso8601DisplayFormat
    normalize
    parse
    parseDate
    parseTime
    format
    parseIso8601
    formatIso8601
    formatAgo
    isDatetime
    isDatetimeJson
    decodeDatetimeJson
    encodeDatetimeJson
    dateFormatToRegExp # for testing
    isTimeString
    formatTimeString
  }
